import React, { useRef, useState } from 'react';
import GlobalHeroSectionStyle from './style';
import { Container, Text } from '@weareconceptstudio/core';
import Button from '@/components/Button';
import { config } from '@/helpers';
import Image from '@/components/Image';
import TitleAnim from '@/animation';

const GlobalHeroSection = ({ title, description, desktop_image, mobile_image, showBtn = true }) => {
	const titleRef = useRef(null);
	const subtitleRef = useRef(null);
	const buttonRef = useRef(null);
	const imageBlockRef = useRef(null);
	const imageRef = useRef(null);

	const [load, setLoad] = useState(true);

	return (
		<GlobalHeroSectionStyle className='global-hero-section'>
			<TitleAnim
				startedAnim={load}
				animRef={titleRef}
				finishPercent={0.2}
				onFinish={() => {
					imageBlockRef?.current?.classList?.add('clip-path');
					imageRef?.current?.classList?.add('scale');
				}}
				onBack={() => {
					imageBlockRef?.current?.classList?.remove('clip-path');
					imageRef?.current?.classList?.remove('scale');
				}}
			/>

			<TitleAnim
				startedAnim={load}
				animType='subtitle'
				animRef={subtitleRef}
				configAnim={{ delay: 0.3, duration: 0.7 }}
				finishPercent={0.6}
				onFinish={() => {
					showBtn && buttonRef?.current?.classList?.add('active-button');
				}}
				onBack={() => {
					showBtn && buttonRef?.current?.classList?.remove('active-button');
				}}
			/>

			<Container
				row
				isSection>
				<div className='left-block col-6 col-t-6 col-dx-12'>
					<div className='left-inner-block'>
						<Text
							tag={'h1'}
							ref={titleRef}
							className='h2 black-1000 montserrat-400 title opacity-zero'>
							{title}
						</Text>

						<Text
							ref={subtitleRef}
							className='p p1 black-1000 montserrat-400 description opacity-zero'>
							{description}
						</Text>

						{showBtn && (
							<div
								ref={buttonRef}
								className='btn-block wrapper-button'>
								<Button
									url={config.routes.contactUs.path}
									text={config.routes.contactUs.name}
								/>
							</div>
						)}
					</div>
				</div>

				<div className='empty-block col-1 col-t-0 col-dx-12 empty-col' />

				<div className='right-block col-5 col-t-6 col-dx-12'>
					<div
						ref={imageBlockRef}
						className='right-inner-block'>
						<Image
							priority={true}
							ref={imageRef}
							// onLoad={setLoad}
							double={[desktop_image, mobile_image]}
						/>
					</div>
				</div>
			</Container>
		</GlobalHeroSectionStyle>
	);
};

export default GlobalHeroSection;
